export const DYNAMIC_URLS = {
  dataStreamEdit: ({ dataStreamId }: { dataStreamId: string }) =>
    `/data-streams/${dataStreamId}/edit`,
  invitation: ({ invitationId }: { invitationId: string }) =>
    `/invitation/${invitationId}`,
  templateBranding: ({ templateId }: { templateId: string }) =>
    `/templates/${templateId}/branding`,
  templateEdit: ({ templateId }: { templateId: string }) =>
    `/templates/${templateId}`,
  templateAttachmentEdit: ({
    templateId,
    attachmentName,
  }: {
    templateId: string;
    attachmentName: string;
  }) => `/templates/${templateId}/attachments/${attachmentName}`,
  templateAttachmentAdd: ({ templateId }: { templateId: string }) =>
    `/templates/${templateId}/attachments/add`,
  templateAttachmentAddFromTemplate: ({
    templateId,
    baseTemplateId,
  }: {
    templateId: string;
    baseTemplateId: string;
  }) => `/templates/${templateId}/attachments/add/${baseTemplateId}`,
  formEdit: ({ formId }: { formId: string | number }) => `/forms/${formId}`,
  transactionDetails: ({
    transactionId,
    transactionDataStream,
    tab,
  }: {
    transactionId: string;
    transactionDataStream: string;
    tab?: string;
  }) =>
    `/transactions/${transactionId}/streams/${transactionDataStream}/details${
      tab ? `/${tab}` : ''
    }`,
  transactionEntries: ({
    transactionId,
    transactionDataStream,
  }: {
    transactionId: string;
    transactionDataStream: string;
  }) =>
    `/transactions/${transactionId}/streams/${transactionDataStream}/entries`,
  transactionEntry: ({
    transactionId,
    transactionDataStream,
    transactionEntry,
    tab,
  }: {
    transactionId: string;
    transactionDataStream: string;
    transactionEntry: string;
    tab?: string;
  }) =>
    `/transactions/${transactionId}/streams/${transactionDataStream}/entries/${transactionEntry}${
      tab ? `/${tab}` : ''
    }`,
  organisationDetails: ({ organisationId }: { organisationId: string }) =>
    `/organisations/${organisationId}/details`,
  organisationBoards: ({ organisationId }: { organisationId: string }) =>
    `/organisations/${organisationId}/boards`,

  organisationBoard: ({
    organisationId,
    boardId,
  }: {
    organisationId: string;
    boardId: string;
  }) => `/organisations/${organisationId}/boards/${boardId}`,
  organisationBoardSettings: ({
    organisationId,
    boardId,
    settingsTabKey,
  }: {
    organisationId: string | number;
    boardId: string | number;
    settingsTabKey: string;
  }) => `/organisations/${organisationId}/boards/${boardId}/${settingsTabKey}`,

  organisationBranding: ({ organisationId }: { organisationId: string }) =>
    `/organisations/${organisationId}/branding`,
  organisationMailCustomization: ({
    organisationId,
  }: {
    organisationId: string;
  }) => `/organisations/${organisationId}/mail-customization`,
  formExternal: ({ formSlug }: { formSlug: string }) =>
    `/ext/forms/${formSlug}`,
  documentSignaturesExternal: ({ docSlug }: { docSlug: string }) =>
    `/ext/documents/${docSlug}`,
  document: ({ documentId }: { documentId: string | number }) =>
    `/contracts/${documentId}`,
  contracts: ({ documentId }: { documentId: string | number }) =>
    `/contracts/${documentId}`,
  package: ({ packageId }: { packageId: string | number }) =>
    `/contracts?f.packageId=${packageId}`,
  archivedPackage: ({ packageId }: { packageId: string | number }) =>
    `/archive/contracts?f.packageId=${packageId}`,
  signe: ({ resourceId }: { resourceId: string | number }) =>
    `/portal?documentIds=${resourceId}`,
  signePackage: ({ packageId }: { packageId: string | number }) =>
    `/portal?packageId=${packageId}`,
  // @deprecated use signe
  transactionPage: ({
    type,
    resourceId,
  }: {
    type: 'doc' | 'package' | string;
    resourceId: string | number;
  }) => `/signe/${type}/${resourceId}`,
  go: ({ id }: { id: string }) => `/go/${id}`,
};
